import { createContext, useContext } from 'react';

// Canvas P3b (SC-2665) — the column-scoped portal target for `CanvasOverlay`.
//
// `WorkspaceShell` renders an absolutely-positioned layer over the content column
// (below the section tabs, beside the permanent ChatPanel) and provides its element
// here; `CanvasOverlay` portals detail overlays into it, so an entity / attribute /
// finding detail covers the view it belongs to WITHOUT covering chat or nav — the
// three-panel payoff (locked decision #1). `null` when there's no root in context
// (e.g. rendered outside `WorkspaceShell`), so `CanvasOverlay` safely no-ops.

export const CanvasOverlayRootContext = createContext<HTMLElement | null>(null);

/** The canvas-column overlay root, or `null` when not inside the canvas shell. */
export function useCanvasOverlayRoot(): HTMLElement | null {
  return useContext(CanvasOverlayRootContext);
}
